import React from "react";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";

export const ProduccionAnterior = (props) => {
    const { produccionAnterior } = props;
    const {
        pesoPacasSecadoraProyectadas = 0,
        pesoPacasReportadas = 0,
        productoPacasSecadoraNombre = null,
        productosReportados = [],
    } = produccionAnterior;

    return (
        <React.Fragment>
            <h5 className="mb-2">Producción turno anterior</h5>
            <div
                className="prod-reportada__prod-anterior mb-4 py-4 px-3 gap-1rem"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <div className="d-flex align-items-center gap-10 flex-1 prod-reportada__prod-anterior-field end">
                    <label className="text-nowrap mb-0 pl-0">
                        Pacas en secadora (proyectadas):
                    </label>
                    <h4 className="text-nowrap mb-0">
                        <RenderKilogramo value={pesoPacasSecadoraProyectadas} />
                    </h4>
                    {productoPacasSecadoraNombre && (
                        <span className="text-nowrap mb-0 pl-0">
                            ({productoPacasSecadoraNombre})
                        </span>
                    )}
                </div>
                {/* LINEA VERTICAL CORTA COMO SEPARACIÓN */}
                <div className="prod-reportada__prod-anterior-linea"></div>
                <div className="d-flex align-items-center gap-10 flex-1 prod-reportada__prod-anterior-field start">
                    <label className="text-nowrap mb-0 pl-0">
                        Pacas producidas:
                    </label>
                    <h4 className="text-nowrap mb-0">
                        <RenderKilogramo value={pesoPacasReportadas} />
                    </h4>
                    {productosReportados.length > 0 && (
                        <span className="text-nowrap mb-0 pl-0">
                            {/* mostrar nombres separados por coma con join */}(
                            {productosReportados
                                .map((producto) => producto.nombre)
                                .join(", ")}
                            )
                        </span>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};
